import Image from '@anm/components/image/Image';
import { FC } from 'react';

import VideoLoadingPreviewWrapper from './Wrapper';

export type VideoLoadingPreviewProps = {
  src: string;
  isVisible?: boolean;
};

const VideoLoadingPreview: FC<VideoLoadingPreviewProps> = ({
  src,
  isVisible
}) => (
  <VideoLoadingPreviewWrapper {...{ isVisible }}>
    <Image {...{ src }} alt="loading" />
  </VideoLoadingPreviewWrapper>
);

export default VideoLoadingPreview;
